function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, FormControl, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Clipboard, ClipboardCheck } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InlineCopy(_ref) {
  var id = _ref.id,
      text = _ref.text,
      center = _ref.center;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCopied = _useState2[0],
      setCopied = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCopiedTooltip = _useState4[0],
      setCopiedTooltip = _useState4[1];

  var selectInput = function selectInput() {
    var input = document.getElementById(id);
    input.select();
  };

  var buttonClickHandler = function buttonClickHandler() {
    selectInput();
    document.execCommand('copy');
    setCopied(true);
    setCopiedTooltip(true);
  };

  var buttonLeaveHandler = function buttonLeaveHandler() {
    return setCopiedTooltip(false);
  };

  var inputClickHandler = function inputClickHandler() {
    return selectInput();
  };

  var ClipboardIcon = isCopied ? ClipboardCheck : Clipboard;
  return /*#__PURE__*/_jsxs(InputGroup, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      id: id,
      value: text,
      readOnly: true,
      onClick: inputClickHandler,
      className: center ? 'text-center' : ''
    }), /*#__PURE__*/_jsx(InputGroup.Append, {
      children: /*#__PURE__*/_jsx(OverlayTrigger, {
        placement: "top",
        show: isCopiedTooltip,
        transition: false,
        overlay: /*#__PURE__*/_jsx(Tooltip, {
          id: "".concat(id, "-copy"),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "common.copied"
          })
        }),
        children: /*#__PURE__*/_jsx(Button, {
          variant: "outline-secondary",
          onClick: buttonClickHandler,
          onMouseLeave: buttonLeaveHandler,
          children: /*#__PURE__*/_jsx(ClipboardIcon, {
            className: "icon"
          })
        })
      })
    })]
  });
}
InlineCopy.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  center: PropTypes.bool
};
InlineCopy.defaultProps = {
  center: false
};